import { render } from "./SubscribePlansCompare.vue?vue&type=template&id=52f02860"
import script from "./SubscribePlansCompare.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePlansCompare.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Subscribe/SubscribePlansCompare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52f02860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52f02860', __exports__)) {
    api.reload('52f02860', __exports__)
  }
  
  module.hot.accept("./SubscribePlansCompare.vue?vue&type=template&id=52f02860", () => {
    api.rerender('52f02860', render)
  })

}


export default __exports__